const SDK_VERSION = '7.21.1';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
